const capabilities = {
  reservations: 'reservations',
  location_mandatory: 'location_mandatory',
  category_mandatory: 'category_mandatory',
  work_item_auto_closure: 'work_item_auto_closure',
  pm_wo_generation_time: 'pm_wo_generation_time',
  ai_chat: 'ai_chat',
  helix_ai: 'helix_ai',
  helix_ai_writes: 'helix_ai_writes',
  fleet_management: 'fleet_management',
  work_request_priority: 'work_request_priority',
  work_request_requested_completion_date: 'work_request_requested_completion_date',
};

export { capabilities };
